import { z } from "zod";

/**
 * Gornja granica spremljene cijene hitne konsultacije (bruto, sa PDV-om, isto
 * značenje kao services.price). Admin raspon cijena usluga se ovdje namjerno ne
 * primjenjuje: hitni termin je skuplja usluga i postojeće cijene su iznad raspona.
 */
export const EMERGENCY_PRICE_MAX = 1000;

const priceSchema = z
  .number({ error: "Cijena hitne konsultacije je obavezna kad su hitni termini uključeni." })
  .positive("Cijena hitne konsultacije mora biti veća od 0.")
  .max(EMERGENCY_PRICE_MAX, `Cijena hitne konsultacije za klijenta (sa PDV-om) može biti najviše ${EMERGENCY_PRICE_MAX} KM.`);

// Isključeni hitni termini ne traže (ni ne provjeravaju) cijenu: spremljena cijena
// ostaje kakva jeste, da se ponovnim uključivanjem ne mora unositi iznova.
export const updateEmergencySettingsSchema = z.discriminatedUnion("enabled", [
  z.object({ enabled: z.literal(true), price: priceSchema }),
  z.object({ enabled: z.literal(false), price: z.unknown().optional() }),
]);
